import * as types from "../types";

const initialState = {
  loading: false,
  manufacturerState: null,
  error: null,
};

export default function fetchManufacturerStateReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_MANUFACTURER_AND_STATE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case types.FETCH_MANUFACTURER_AND_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        manufacturerState: action.payload.manufacturerState,
      };

    case types.FETCH_MANUFACTURER_AND_STATE_FAILURE:
      return {
        ...state,
        loading: false,
        manufacturerState: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}